<template>
  <div >
    <app-header class="haeder-r"></app-header>
    <!--slider end -->

    <div  v-if="project.title"  class="box-title">
      <h2>{{project.title}}</h2>
    </div>
    <div class="blog-page full-page">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-xs-12 col-sm-12 col-md-12 lightgallery">
            <a :href="project.image" >
            <div class="box-big-img-project" :style="'background-image: url('+project.image+')'"></div>
            </a>
          </div>
        </div>
        <div class="row">
          <div class="blog-content">
            <div class="col-md-12 ">
              <p v-html="project.description"></p>
            </div>
            <div class="container-project" >
              <h3 class="text-center" v-if="project.images" v-lang.gallery></h3>
              <div v-for="image,index in project.images" class="col-md-3  col-sm-6 col-xs-12 box-img-project">
                <a @click="openGallery(index)" id="dynamic" >
                  <div class="box-overlay"><i class="fa fa-search" aria-hidden="true"></i></div>
                  <img :src="image.img"  alt="">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
     <app-footer></app-footer>
  </div>
</template>

<script>
import {Urls,checkForDub} from '../config'
  export default {
    mounted(){

      this.get_project()
      this.get_gallery()
      this.get_similar()
    },
    data(){
      return{
        project : {},
        gallery : [],
        similar : []
      }
    },
    methods: {
      get_project(){
        this.loading = true
        let pathArray = window.location.pathname.split('/');
        let slug = pathArray[pathArray.length - 1]
//        if (!this.findItInCash(slug)) {
        this.axios.get(Urls.projectsUrl + '/' + slug)
          .then((response) => {
            // Success
            this.loading = false
            this.project = response.data.data
               setTimeout( () => {
                try {
                    $(".lightgallery").lightGallery({
                    controls : false,
                    enableSwipe : false,
                    })
                } catch (e) {ce(e)}
                },100)
          }).catch((errors) => {
          // error
          this.loading = false
          console.log(errors)
          this.err = errors
        })
//        }
      },
      get_gallery(){
        this.loading = true
        let pathArray = window.location.pathname.split('/');
        let slug = pathArray[pathArray.length - 1]
//        if (!this.findItInCash(slug)) {
        this.axios.get(Urls.galleryUrl + '/' + slug)
          .then((response) => {
            // Success
            this.loading = false
            response.data.data.forEach(image => {
                this.gallery.push(image)
            })
          }).catch((errors) => {
          // error
          this.loading = false
          console.log(errors)
          this.err = errors
        })
//        }
      },
      get_similar(){
        this.loading = true
        let pathArray = window.location.pathname.split('/');
        let slug = pathArray[pathArray.length - 1]
//        if (!this.findItInCash(slug)) {
        this.axios.get(Urls.similarUrl + '/' + slug + '/3')
          .then((response) => {
            // Success
            this.loading = false
            response.data.data.forEach(project => {
              this.similar.push(project)
            })
          }).catch((errors) => {
          // error
          this.loading = false
          console.log(errors)
          this.err = errors
        })
      },
      openGallery(index){
        var $lg = $('#dynamic');
        var lg = $lg.lightGallery({
                    dynamic: true,
                    dynamicEl: this.gallery,
                    index: parseInt(index),
                    download : false
                });
        lg.one("onCloseAfter.lg", function() {
            lg.data('lightGallery').destroy(true);
        });
      },
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/project.vue